import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { submitForm, updateAccidentForm } from '../../../../redux/modules/accidentClaim';
import conclusionSchema from '../../../../validations/claimValidationSchema/conclusionSchema';
import ConclusionStep from '../../../CompensationContainer/Steps/ConclusionStep';

const AccidentConclusionStep = ({ step, goNext, goPrevious, params: { setStepNavigationBox } }) => {
  const accidentClaim = useSelector((store) => store.accidentClaim, shallowEqual);

  return (
    <ConclusionStep
      claim={accidentClaim}
      isSubmitting={accidentClaim.isSubmitting}
      setStepNavigationBox={setStepNavigationBox}
      goPrevious={goPrevious}
      goNext={goNext}
      updateForm={updateAccidentForm}
      step={step}
      validationSchema={conclusionSchema}
      submitForm={submitForm}
    />
  );
};

AccidentConclusionStep.propTypes = {
  step: PropTypes.shape({
    claimForm: PropTypes.string.isRequired,
    n: PropTypes.number.isRequired,
  }).isRequired,
  goNext: PropTypes.func.isRequired,
  goPrevious: PropTypes.func.isRequired,
  params: PropTypes.shape({
    setStepNavigationBox: PropTypes.func.isRequired,
  }).isRequired,
};

export default AccidentConclusionStep;
